/**
 *
 * ModalSelectLeader
 *
 */

import React, { Component } from "react"
// import PropTypes from 'prop-types';
import { Modal, Button, Select, Spin, Tooltip } from "antd"
import { map, debounce, filter, find } from "lodash"
import SelectorHR from "components/Select"
import "./index.less"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class ModalSelectLeader extends Component {
  state = {
    potentialLeaders: [],
    idLeaderSelected: undefined,
    searchLeaderValue: "",
    isLoadingSearchLeaders: false,
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (Array.isArray(prevProps.potentialLeaders)) {
      if (
        prevProps.potentialLeaders.length !== this.props.potentialLeaders.length
      ) {
        this.setState({
          potentialLeaders: this.props.potentialLeaders.slice(0, 100),
        })
      }
    }
  }

  handleInputSearch = (value) => {
    if (value) {
      this.setState({
        searchLeaderValue: value,
        potentialLeaders: filter(this.props.potentialLeaders, (item) =>
          item.full_name.toLowerCase().includes(value.toLowerCase())
        ),
      })
    } else {
      this.setState({
        searchLeaderValue: "",
        potentialLeaders: this.props.potentialLeaders.slice(0, 100),
      })
    }

    this.setState({ isLoadingSearchLeaders: false })
  }

  searchLeader = debounce(this.handleInputSearch, 500)

  getFullNameFromId = () => {
    const leader = find(
      this.props.potentialLeaders,
      (item) => item.id_employee === this.state.idLeaderSelected
    )

    if (!leader) return undefined

    return leader.full_name
  }

  render() {
    return (
      <Modal
        title="Seleccionar líder"
        className="modal-select-leader"
        style={{ top: 76 }}
        visible={this.props.visible}
        width={420}
        onCancel={() => this.props.setStateFrom("modalSelectLeader", false)}
        footer={[
          <Button
            key="back"
            onClick={() => {
              this.setState({ idLeaderSelected: undefined })
              this.props.setStateFrom("modalSelectLeader", false)
            }}>
            Cancelar
          </Button>,
          <Button
            disabled={!this.state.idLeaderSelected}
            key="submit"
            type="primary"
            onClick={() => {
              let search_data= {
                ...this.props.paginationRecord,
                leaders: this.props.leadersSelected,
                divisions: this.props.divisionsSelected,
                segments: this.props.segmentsSelected
              }
              const params = {
                idLeader: this.props.collaboratorSelected.id_employee,
                idEmployee: this.state.idLeaderSelected,
                search_data: search_data
              }
              this.props.assignLeader(params)
              this.props.setStateFromCollaborators("inputSearch", "")
              this.props.setStateFrom("modalSelectLeader", false)
              this.setState({ idLeaderSelected: undefined })
            }}>
            Aceptar
          </Button>,
        ]}>
        <p style={{ marginBottom: 20 }}>
          Selecciona al colaborador que deseas asignar como
          <span style={{ fontWeight: 500 }}> líder:</span>
        </p>

        <SelectorHR
          placeholder="Buscar..."
          options={this.props.potentialLeaders}
          labelKey="id_employee"
          label="full_name"
          value={this.getFullNameFromId()}
          allowClear
          onChange={(e) => this.setState({ idLeaderSelected: e.id_employee })}
          isLoading={this.props.isLoadingPotentialLeaders}
          disabled={this.props.isLoadingPotentialLeaders}
        />
      </Modal>
    )
  }
}

ModalSelectLeader.propTypes = {}

export default ModalSelectLeader
